import { render, staticRenderFns } from "./Uhistorytable.vue?vue&type=template&id=538f1730"
import script from "./Uhistorytable.vue?vue&type=script&lang=js"
export * from "./Uhistorytable.vue?vue&type=script&lang=js"
import style0 from "./Uhistorytable.vue?vue&type=style&index=0&id=538f1730&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports